import { t } from '@lingui/core/macro';
import { Availability, AvailabilityType } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';
import { type AvailabilityRenderOption, formatAvailabilityDuration } from '@luminovo/data-stack';

export function formatAvailability(
    availability: null | undefined | Availability,
    renderOption: AvailabilityRenderOption = 'days',
): string {
    if (!availability) {
        return t`Unknown`;
    }
    switch (availability.type) {
        case AvailabilityType.LeadTime:
        case AvailabilityType.OnOrder:
            return formatAvailabilityDuration(availability.days, renderOption);
        case AvailabilityType.OnOrderWithUnknownLeadTime:
            return t`On order`;
        case AvailabilityType.Stock:
            return t`In stock`;
        default:
            /* c8 ignore next */
            assertUnreachable(availability);
    }
}
